import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import VoucherCard from "../components/VoucherCard";
import { BrandLogo } from "../components/Brand";
import { Search } from "lucide-react";

export default function SearchPage() {
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const [busy, setBusy] = useState(false);
    const [brands, setBrands] = useState([]);
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        if (!q.trim()) return;
        setBusy(true);
        api.get(`/api/search?q=${encodeURIComponent(q)}`).then((r) => {
            setBrands(r.data.brands);
            setRewards(r.data.rewards);
            setBusy(false);
        });
    }, [q]);

    return (
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
            <h1 className="font-display text-2xl md:text-3xl font-bold flex items-center gap-2">
                <Search size={22} className="text-[#c9a959]" /> Search results
            </h1>
            <p className="text-[#6b7280] text-sm mt-1">
                Query: <span className="text-[#0b1437] font-semibold">"{q}"</span> • {brands.length} brands • {rewards.length} vouchers
            </p>

            {brands.length > 0 && (
                <section className="mt-6">
                    <h2 className="font-display text-lg font-semibold mb-3">Brands</h2>
                    <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-8 gap-3">
                        {brands.map((b) => (
                            <Link
                                key={b.id}
                                to={`/brand/${b.slug}`}
                                className="fx-card p-3 flex flex-col items-center gap-2 hover:border-[#c9a959]/40"
                            >
                                <BrandLogo url={b.logo_url} name={b.name} size={48} />
                                <p className="text-xs font-semibold truncate w-full text-center">{b.name}</p>
                            </Link>
                        ))}
                    </div>
                </section>
            )}

            <section className="mt-8">
                <h2 className="font-display text-lg font-semibold mb-3">Vouchers</h2>
                {busy && (
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
                        {Array.from({ length: 10 }).map((_, i) => (
                            <div key={i} className="aspect-[4/5] fx-card animate-pulse bg-[#f9fafb]" />
                        ))}
                    </div>
                )}
                {!busy && rewards.length === 0 && (
                    <div className="fx-card p-10 text-center text-[#6b7280]">
                        No vouchers match "{q}". Try a different brand or category.
                    </div>
                )}
                {!busy && rewards.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
                        {rewards.map((r) => <VoucherCard key={r.id} r={r} />)}
                    </div>
                )}
            </section>
        </div>
    );
}
